export default __webpack_public_path__ + "e031860fa4e01e85c3264e660e36d4d3.png";